import { forwardRef, MouseEventHandler, useState } from 'react';

import {
  CheckboxV2,
  FAIconName,
  FireflyButton,
  Icon,
  Popover,
} from '@equip.health/ui';

/** Vertical gap between the trigger icon and the popover content. */
const TRIGGER_GAP = '10px';

interface ScheduleFiltersTriggerProps {
  buttonId: string;
  onClick?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
}

const ScheduleFiltersTrigger = forwardRef<
  HTMLButtonElement,
  ScheduleFiltersTriggerProps
>(({ buttonId, onClick }, ref) => (
  <FireflyButton
    aria-label="Schedule filters"
    id={buttonId}
    onClick={onClick}
    ref={ref}
    variant="tertiary"
  >
    <Icon name={FAIconName.gearRegular} size="lg" />
  </FireflyButton>
));

ScheduleFiltersTrigger.displayName = 'ScheduleFiltersTrigger';

interface ScheduleFiltersPopoverProps {
  id: string;
  onShowCancelledAppointmentsChange: (isChecked: boolean) => void;
  shouldShowCancelledAppointments: boolean;
}

const ScheduleFiltersPopover = ({
  id,
  onShowCancelledAppointmentsChange,
  shouldShowCancelledAppointments,
}: ScheduleFiltersPopoverProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <Popover
      bodyContent={
        <CheckboxV2
          id={`${id}__show-cancelled-appointments-checkbox`}
          isChecked={shouldShowCancelledAppointments}
          label="Show cancelled appointments and no-shows"
          onChange={onShowCancelledAppointmentsChange}
        />
      }
      bodyPadding="16px"
      id={id}
      isOpen={isOpen}
      margin={`${TRIGGER_GAP} 0px 0px 0px`}
      onClose={() => setIsOpen(false)}
      onOpen={() => setIsOpen(true)}
      placement="bottom-end"
      size="md"
      triggerContent={<ScheduleFiltersTrigger buttonId={`${id}__trigger`} />}
    />
  );
};

export default ScheduleFiltersPopover;
